import { CompanyType } from "@/features/types";

// 라인시트세트 상세(오더 보기) 오른쪽 영역의 탭.
export type RightPanelTab =
  | "LINE_SHEET"
  | "ORDER_CONFIRMATION"
  | "PROFORMA"
  | "TRANSPORTATION"
  | "BALANCE"
  | "INQUIRY";

export const DEFAULT_RIGHT_PANEL_TAB: RightPanelTab = "LINE_SHEET";

// 회사 종류별로 보이는 탭. 부티크는 에이전시와 같은 구성에서 오더컨펌·크레딧/디파짓만 뺀다
// (둘 다 에이전시와 바이어 사이의 정산이라 부티크 몫이 아니다). 바이어는 전용 화면을 쓴다.
export function getRightPanelTabs(
  companyType: CompanyType | undefined,
  isSeasonLineSheetSet: boolean
): RightPanelTab[] {
  if (companyType === "AGENCY") {
    return [
      "LINE_SHEET",
      ...(isSeasonLineSheetSet ? (["ORDER_CONFIRMATION"] as const) : []),
      "PROFORMA",
      "TRANSPORTATION",
      "BALANCE",
      "INQUIRY",
    ];
  }
  if (companyType === "BOUTIQUE") {
    return ["LINE_SHEET", "PROFORMA", "TRANSPORTATION", "INQUIRY"];
  }
  return [];
}

// URL 에 남아 있던 탭이 지금 회사에는 없는 탭이면(예: 부티크가 받은 오더컨펌 링크) 기본 탭으로 돌린다.
export function resolveRightPanelTab(
  raw: string | undefined,
  tabs: RightPanelTab[]
): RightPanelTab {
  if (raw && (tabs as string[]).includes(raw)) {
    return raw as RightPanelTab;
  }
  return DEFAULT_RIGHT_PANEL_TAB;
}

// 프로포마·운송 추가/수정은 에이전시만 한다. 부티크는 보기만 하고, 눌러도 상세 화면으로 간다.
export function canManageRightPanelItems(
  companyType: CompanyType | undefined
): boolean {
  return companyType === "AGENCY";
}
